/**
 * Bedienelemente für die Leadsheet-Angaben (Titel, Tempo).
 *
 * Die Ansicht bindet vorhandene Eingabefelder an den Controller. Die
 * Event-Handler enthalten keine fachliche Logik – Normalisierung und
 * Begrenzung liegen im Modell/Controller.
 */

import type { EditorController } from '../app/EditorController';

export class LeadsheetControls {
  readonly #controller: EditorController;

  constructor(controller: EditorController) {
    this.#controller = controller;
  }

  /** Bindet Titel- und Tempo-Feld an den Controller. */
  mount(titleInput: HTMLInputElement, tempoInput: HTMLInputElement): void {
    const { title, tempo } = this.#controller.meta;
    titleInput.value = title;
    tempoInput.value = String(tempo);

    titleInput.addEventListener('input', () => {
      this.#controller.setTitle(titleInput.value);
    });

    tempoInput.addEventListener('change', () => {
      this.#controller.setTempo(Number(tempoInput.value));
      // Begrenzten/gerundeten Wert zurückspiegeln.
      tempoInput.value = String(this.#controller.meta.tempo);
    });
  }
}
